import { useQuery } from '@tanstack/react-query';
import type { Telemetry } from '@bridgewerk/shared';
import { getApiClient, type TelemetryQuery } from '../../../lib/api-client.js';
import { machineKeys } from '../../../lib/query-keys.js';

export interface UseMachineTelemetryArgs {
  readonly shopId: string | null;
  readonly machineId: string | null;
  readonly range: TelemetryQuery;
}

export interface MachineTelemetryQuery {
  readonly points: Telemetry[] | undefined;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly refetch: () => void;
}

export function useMachineTelemetry({
  shopId,
  machineId,
  range,
}: UseMachineTelemetryArgs): MachineTelemetryQuery {
  const enabled = !!shopId && !!machineId;
  const query = useQuery({
    queryKey: enabled
      ? machineKeys.telemetry(shopId!, machineId!, range)
      : ['machines', 'none', 'telemetry'],
    queryFn: () => getApiClient().getMachineTelemetry(shopId!, machineId!, range),
    enabled,
  });
  return {
    points: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
  };
}
